var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurolatorSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 154 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_819)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.794 6.39465C105.146 6.39465 102.767 7.11855 101.463 7.67849L99.968 10.9438C101.425 10.274 103.381 9.60507 105.376 9.60507C107.446 9.60507 107.563 10.6487 107.101 11.6374L106.948 11.9071C102.151 11.9071 97.5857 13.7263 95.7079 17.7656C94.52 20.3595 95.4024 22.5 98.3153 22.5C100.004 22.5 101.769 21.8556 103.305 20.6521H103.418L102.958 22.1754H107.178C107.446 21.24 108.023 19.9061 108.636 18.5149L111.207 12.9762C112.777 9.55014 112.932 6.39465 107.794 6.39465ZM104.8 16.9072C104.686 17.1761 104.532 17.4425 104.34 17.6836C103.572 18.646 102.384 19.2634 101.387 19.2634C100.464 19.2634 99.8502 18.6723 100.503 17.3114C101.425 15.3299 103.689 14.7675 105.798 14.7675L104.8 16.9072Z",
    fill: "#DA322A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1916 6.68976L54.8186 16.212C54.587 16.667 54.3173 17.0687 54.0491 17.3638C53.473 18.0328 52.4785 18.7788 51.3646 18.7788C49.8687 18.7788 49.8687 17.4425 50.8665 15.2749L54.856 6.68976H50.1376L45.8808 15.916C43.7691 20.4398 44.7271 22.5 47.9138 22.5C50.2522 22.5 52.2478 21.2399 53.3983 20.2512H53.473L52.8222 22.1753H57.0035C57.2708 21.2399 57.8079 19.8774 58.4627 18.5148C59.0746 17.1761 63.9083 6.68976 63.9083 6.68976H59.1916Z",
    fill: "#DA322A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5229 19.1838C76.6826 19.1838 76.7963 17.0687 78.0257 14.4199C79.0592 12.1998 80.8638 9.71246 82.9349 9.71246C84.8151 9.71246 84.3552 12.1998 83.3176 14.4199C82.1289 16.99 80.2861 19.1838 78.5619 19.1838H78.5229ZM76.9491 22.5C80.4413 22.5 85.3879 20.3316 88.1895 14.3412C90.376 9.55014 88.9955 6.39465 84.5835 6.39465C80.2495 6.39465 75.6458 9.2837 73.2285 14.5248C70.9267 19.5298 72.6151 22.5 76.9491 22.5Z",
    fill: "#DA322A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.392 19.1838C126.549 19.1838 126.703 17.0687 127.892 14.4199C128.928 12.1998 130.771 9.71246 132.802 9.71246C134.719 9.71246 134.221 12.1998 133.185 14.4199C132.035 16.99 130.156 19.1838 128.429 19.1838H128.392ZM126.856 22.5C130.308 22.5 135.298 20.3316 138.06 14.3412C140.243 9.55014 138.902 6.39465 134.451 6.39465C130.156 6.39465 125.551 9.2837 123.135 14.5248C120.796 19.5298 122.484 22.5 126.819 22.5H126.856Z",
    fill: "#DA322A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.094 6.475C152.789 6.39465 152.556 6.39465 152.136 6.39465C150.717 6.39465 148.644 7.30465 146.918 9.31157H146.803L147.802 6.68979H143.771C143.198 8.0802 142.506 9.66 141.626 11.6112L136.716 22.1754H139.246C140.665 22.1754 141.779 21.4285 142.429 20.0373L145.078 14.3412C145.307 13.8312 145.576 13.3795 145.807 13.0565C146.918 11.5062 148.528 10.7307 149.949 10.7307C150.449 10.7307 150.754 10.7561 151.062 10.8086L153.094 6.475Z",
    fill: "#DA322A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.532 18.7534C117.305 18.7534 116.998 18.0574 117.842 16.239L120.757 9.98136H123.558L125.089 6.68979H122.253L124.17 2.57019H121.715C120.296 2.57019 119.184 3.34738 118.532 4.73861L117.612 6.68979H115.579L114.082 9.98136H116.079L112.97 16.7465C111.895 19.0477 111.741 20.4136 112.243 21.2703C112.7 22.0426 113.736 22.4713 115.196 22.4713C116.461 22.4713 117.612 22.3106 118.34 22.0999L119.951 18.6214C119.492 18.7264 119.184 18.7534 118.532 18.7534Z",
    fill: "#DA322A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1259 2.57019C96.7048 2.57019 95.5543 3.34738 94.9417 4.73861L86.8481 22.1754H89.3808C90.7986 22.1754 91.9093 21.4285 92.5626 20.0373L100.656 2.57019H98.1259Z",
    fill: "#DA322A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2218 6.475C75.952 6.39465 75.7213 6.39465 75.2614 6.39465C73.8817 6.39465 71.7716 7.30465 70.0832 9.31157H69.9296L70.9656 6.68979H66.8997C66.3253 8.0802 65.672 9.66 64.7506 11.6112L59.8804 22.1754H62.3732C63.8309 22.1754 64.944 21.4285 65.5965 20.0373L68.2047 14.3412C68.4346 13.8312 68.7019 13.3795 68.9343 13.0565C70.045 11.5062 71.6554 10.7307 73.0757 10.7307C73.5746 10.7307 73.9207 10.7561 74.2271 10.8086L76.2218 6.475Z",
    fill: "#DA322A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.874 7.65223C49.1017 4.6025 49.1017 1.15106 42.4268 1.15106H36.4434L26.7004 22.1753H29.1534C30.6127 22.1753 31.7251 21.4285 32.3775 20.0373L34.9865 14.4198C35.3302 14.4485 35.7893 14.4748 36.289 14.4748C38.7055 14.4748 41.4307 14.2313 43.6927 12.7351C45.4965 11.5587 46.9542 9.89854 47.874 7.65223ZM37.8239 10.9151C37.3234 10.9151 36.9423 10.9151 36.6343 10.8364L39.5895 4.441C40.0494 4.36394 40.5466 4.38853 41.3153 4.38853C43.5798 4.38853 44.1542 5.56743 43.232 7.62764C42.3131 9.71244 40.2777 10.9151 37.8239 10.9151Z",
    fill: "#DA322A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.071 1.15106H24.0912L14.384 22.1753H20.1001C21.5586 22.1753 22.6726 21.4285 23.3234 20.0373C23.975 18.646 32.071 1.15106 32.071 1.15106Z",
    fill: "#22387D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_233_819",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 22,
    height: 22
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0.048584 1.15106H21.5195V22.1753H0.048584V1.15106Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_233_819)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5198 1.15106L11.8158 22.1753H8.13428L16.8811 3.29161C17.5319 1.92989 18.6434 1.15106 20.0629 1.15106H21.5198Z",
    fill: "#DA322A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0135 12.6285H0.960401C0.422511 12.6285 0 13.0565 0 13.591C0 13.8312 0.116191 14.0731 0.269757 14.26L6.40755 20.4111L10.0135 12.6285Z",
    fill: "#22387D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153.567,
    height: 22.1351,
    fill: "white",
    transform: "translate(0 0.364868)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurolatorSvg);
export default __webpack_public_path__ + "static/media/purolator-svg.a0c910a4e9aa21806425864749ea8789.svg";
export { ForwardRef as ReactComponent };